import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { InstanceBox } from "./InstanceBox";
import { ConfigInstanceDialog } from "../../../components/ConfigInstanceDialog";
import { QRCodeDialog } from "../../../components/QRCodeDialog";
// import { AlertDialog } from "../../../components/AlertDialog";
import { useToast } from "../../../hooks/useToast";
import {
  getInstances,
  getStores,
  postInstances,
  putInstance,
  deleteInstance,
  zapiDisconnect,
} from "../../../services/whatsapp";
import {
  Instance as InstanceType,
  putInstanceObject,
} from "../../../types/whatsapp";
import { FormikInstance } from "../../../components/ConfigInstanceDialog";
import { ImportContactList } from "../../../components/ImportContactList";

export function Instances() {
  const [openDialogConfigInstance, setOpenDialogConfigInstance] =
    useState<boolean>(false);
  // const [openDialogDeleteInstance, setOpenDialogDeleteInstanceDialog] =
  //   useState<boolean>(false);
  const [openDialogQRCode, setDialogOpenQRCode] = useState<boolean>(false);
  const [isOpenQRCodeAfterCreateInstance, setIsOpenQRCodeAfterCreateInstance] =
    useState<boolean>(false);
  const [
    idInstanceOpenQrCodeAfterCreated,
    setIdInstanceOpenQrCodeAfterCreated,
  ] = useState<number | null>(null);
  const [instanceOnDialog, setInstanceOnDialog] = useState<InstanceType | null>(
    null
  );
  const [openImportFileContacts, setImportFileContacts] =
    useState<boolean>(false);

  const [onEdit, setOnEdit] = useState<boolean>(false);

  const queryClient = useQueryClient();
  const toast = useToast();
  const stores = useQuery("stores", getStores);

  const instances = useQuery("instances", () => getInstances(), {
    cacheTime: 0,
  });

  useEffect(() => {
    if (isOpenQRCodeAfterCreateInstance && Boolean(instances.data?.length)) {
      const findInstance = instances.data?.find(
        (instance) => instance.id === idInstanceOpenQrCodeAfterCreated
      );

      if (findInstance) {
        handleDialogQrCode(findInstance);
      }
    }
  }, [
    isOpenQRCodeAfterCreateInstance,
    idInstanceOpenQrCodeAfterCreated,
    instances.data,
  ]);

  const createInstance = useMutation(postInstances, {
    onSuccess: () => {
      queryClient.invalidateQueries("instances");
      toast.show("Instância criada com sucesso!", { severity: "success" });
    },
    onError: ({ response }) => {
      if (response?.data.code === 404) {
        if (response.data?.message === "Phone already exists") {
          toast.show("Não é permitido criar instâncias com o mesmo número!", {
            severity: "error",
          });
        }
      } else {
        toast.show("Falha ao criar a instancia!", { severity: "error" });
      }
    },
  });

  const dataPutInstance = useMutation(putInstance, {
    onSuccess: () => {
      queryClient.invalidateQueries("instances");
      toast.show("Instância atualizada com sucesso!", { severity: "success" });
    },
    onError: () => {
      toast.show("Falha ao atualizar instancia!", { severity: "error" });
    },
  });

  const mutateDeleteInstance = useMutation(deleteInstance, {
    onSuccess: () => {
      queryClient.invalidateQueries("instances");
      toast.show("Instância deletada com sucesso!", { severity: "success" });
    },
    onError: () => {
      toast.show("Erro ao deletar a instância!", { severity: "error" });
    },
  });

  const mutateDisconnectInstance = useMutation(
    async (idInstance: number) => {
      toast.show("Desconectando a instância", { severity: "info" });
      return await zapiDisconnect(idInstance);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries("instances");
        toast.show("Instância desconectada com sucesso!", {
          severity: "success",
        });
      },
      onError: () => {
        toast.show("Erro ao desconectar a instância!", { severity: "error" });
      },
    }
  );

  // const handleDialogDeleteInstance = (
  //   action = false,
  //   instance: InstanceType | null = null
  // ) => {
  //   setInstanceOnDialog(instance);
  //   setOpenDialogDeleteInstanceDialog(action);
  // };

  // const handleDeleteInstance = () => {
  //   if (instanceOnDialog) {
  //     mutateDeleteInstance.mutateAsync(instanceOnDialog.id!);
  //   }
  //   handleDialogDeleteInstance();
  // };

  const handleDialogConfigInstance = (
    action = false,
    instance: InstanceType | null = null,
    onEdit = false
  ) => {
    setOnEdit(onEdit);
    setInstanceOnDialog(instance);
    setOpenDialogConfigInstance(action);
  };

  const handleDialogQrCode = (instance: InstanceType) => {
    setInstanceOnDialog(instance);
    setDialogOpenQRCode(true);
  };

  const handleDialogImportContactList = (action = false) => {
    setImportFileContacts(action);
  };

  const saveInstance = async (instance: FormikInstance) => {
    try {
      let idInstance: number | null = instanceOnDialog && instanceOnDialog.id;

      if (!idInstance) {
        const dataCreate = await createInstance.mutateAsync(instance);
        idInstance = dataCreate.data.content.instance_id;
        if (isOpenQRCodeAfterCreateInstance) {
          setIdInstanceOpenQrCodeAfterCreated(idInstance);
        }
      }
      const instanceCurrent: putInstanceObject = {
        ...instance,
        id: idInstance!,
        active: 1,
        save_contacts: 0,
        chat_duration: 12,
      };
      await dataPutInstance.mutateAsync(instanceCurrent);
      handleDialogConfigInstance();
    } catch (err) {}
  };

  const handleClose = () => {
    setDialogOpenQRCode(false);
    handleDialogConfigInstance();
    setIdInstanceOpenQrCodeAfterCreated(null);
    setIsOpenQRCodeAfterCreateInstance(false);
  };

  if (
    instances.isLoading ||
    mutateDeleteInstance.isLoading ||
    dataPutInstance.isLoading
  ) {
    return (
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <Typography variant="subtitle1">Buscando informações</Typography>
        <LinearProgress variant="indeterminate" sx={{ width: "25%" }} />
      </Stack>
    );
  }

  return (
    <Box>
      <Box
        px={"2.5rem"}
        display={"flex"}
        flexDirection={"row"}
        gap={"1.5rem"}
        mb={3}
      >
        <Button
          variant="contained"
          onClick={() => {
            setIsOpenQRCodeAfterCreateInstance(true);
            handleDialogConfigInstance(true, null);
          }}
          sx={{ maxWidth: "300px" }}
        >
          Conectar novo whatsapp
        </Button>

        <Button
          variant="outlined"
          onClick={() => {
            handleDialogImportContactList(true);
          }}
          sx={{
            maxWidth: "300px",
            backgroundColor: "#FFF",
            border: "1px solid #B0B0B0",
            color: "#616161",
            "&:hover": {
              backgroundColor: "#FFF",
              color: "#616161",
              border: "1px solid #B0B0B0",
            },
          }}
        >
          Importar lista de contatos
        </Button>
      </Box>
      <Box px={"2.5rem"}>
        {instances.data?.map((instance) => (
          <InstanceBox
            key={instance.nome}
            instance={instance}
            stores={stores.data}
            loadingDisconnect={mutateDisconnectInstance.isLoading}
            onDisconnect={() =>
              mutateDisconnectInstance.mutateAsync(instance.id!)
            }
            onQrCode={() => handleDialogQrCode(instance)}
            onEdit={() => handleDialogConfigInstance(true, instance, true)}
            // onDelete={() => handleDialogDeleteInstance(true, instance)}
          />
        ))}
      </Box>

      {openDialogConfigInstance && (
        <ConfigInstanceDialog
          open={openDialogConfigInstance}
          hasBeenPresentedWarning={onEdit}
          instance={instanceOnDialog!}
          stores={stores.data}
          isNewInstance={Boolean(!instanceOnDialog)}
          onSave={(instance) => {
            saveInstance(instance);
          }}
          onClose={handleDialogConfigInstance}
          loadingSubmit={createInstance.isLoading || dataPutInstance.isLoading}
        />
      )}

      <QRCodeDialog
        open={openDialogQRCode}
        instance={instanceOnDialog!}
        close={handleClose}
      />

      {/* <AlertDialog
        open={openDialogDeleteInstance}
        contentText={
          "Ao excluir um número, você estará apenas desvinculando seu whatsapp a Datasales. Nada acontecerá com seu Whatsapp."
        }
        title={"Deseja excluir o vínculo deste whatsapp?"}
        textAgree={"Desvincular da Datasales"}
        handleClose={() => handleDialogDeleteInstance()}
        handleAgree={() => handleDeleteInstance()}
      /> */}

      <ImportContactList
        open={openImportFileContacts}
        onClose={() => handleDialogImportContactList()}
        identificator="numero"
      />
    </Box>
  );
}
